module.exports = __webpack_public_path__ + "static/media/overview-hsd-summary-duration-icon.c8920f14.png";